import { useQuery } from 'react-query'
import { PaginatedRequest } from '../../../core/interfaces'
import { ProductFilter } from '../../../entities/product'
import { getAllProducts } from '../../products'

export default function useProducts(query: PaginatedRequest<ProductFilter>) {
  const { data, error, isLoading, isFetching, isPreviousData } = useQuery(
    ['products', query],
    () => getAllProducts(query),
    {
      enabled: !!query.filters?.priceTableId
    }
  )
  return { data, error, isLoading, isFetching, isPreviousData }
}
